import im from '_c/business/api/im';
import {
  CustomMessageClickData,
  ReportData,
} from '_c/typings/model/chat/text-node';
import { useStore } from '@/store';
import { BotPageHandle } from './bot-page-handle';
import { logger } from '_c/util/logger';
import { toast } from '@/component/kk-toast';
import { report } from '_c/business/api/report';
import { UserManager } from '_c/business/manager/user';
import { MsgL2Type } from '_c/typings/proto';
import { parseQueryString, parseUrl } from '_c/util/uri';

type ReportHandlerData = {
  cId: string;
  gId: string;
  uId: number;
  reportInfo: ReportData | undefined;
};
function pushUrl(
  attr: CustomMessageClickData,
  reportInfo?: ReportData,
): void {
  const currentUid = Number(UserManager.getInstance().getCurrentUid());
  const store = useStore();
  const cId = store.state.group.selectChannelId;
  const gId = store.state.group.selectGroupId;
  const reportData: ReportHandlerData = {
    cId,
    gId,
    uId: currentUid,
    reportInfo,
  };
  const onClick = attr;
  if (onClick === undefined) return;
  // if (onClick.action === 'webhook') {
  if (onClick.action === 'webhook') {
    const { botId, target, params } = onClick;
    const tempBotId = `${botId}`;
    onReportHandler(reportData);
    if (onClick.wait === true) {
      im.postWebhookMessage(tempBotId, target as string, params as string).then((hookResult) => {
        toast(hookResult.msg);
      });
    }
    im.postWebhookMessage(tempBotId, target as string, params as string);
    // 判断webhook
  } else if (onClick.action === 'scheme') {
    const url = onClick.uri;
    const urlObj = parseUrl(url || '');
    if (!urlObj) return;
    const queryObj = parseQueryString(urlObj.search || '');
    if (urlObj.protocol === 'http:' || urlObj.protocol === 'https:') {
      onReportHandler(reportData);
      if (!onClick.botH5) {
        // 普通http链接跳转,ok
        window.open(url);
      } else {
        // both5跳转
        // 调用openh5方法
        let params = null;
        if (onClick.ext && typeof onClick.ext === 'string') {
          params = JSON.parse(onClick.ext);
        } else {
          params = onClick.ext;
        }
        const tempGid = `${onClick.gid}`;
        const tempBotId = `${onClick.botId}`;
        logger.info('inboth5', tempGid, tempBotId, params);
        BotPageHandle.getInstance().openH5(
          tempGid,
          onClick.uri as string,
          tempBotId,
          undefined,
          params,
        );
      }
    } else if (urlObj.protocol === 'kknk:' && urlObj.host === 'bot' && queryObj.gid && queryObj.botId) { // kkbot设置页,实现
      // 调用openconfig,有ext需要传递
      onReportHandler(reportData);
      const tempParams = onClick.ext;
      let params;
      if (tempParams && typeof tempParams === 'string') {
        params = JSON.parse(tempParams);
      } else if (
        Object.prototype.toString.call(tempParams).slice(8, -1) === 'Object'
      ) {
        params = tempParams;
      } else {
        logger.error('链接格式有误', tempParams);
      }
      logger.info('展示params', params);
      BotPageHandle.getInstance().openConfig(
        queryObj.gid as string,
        queryObj.botId as string,
        undefined,
        params,
      );
    } else {
      toast({
        type: 'error',
        content: '暂不支持跳转到此链接',
      });
    }
  } else {
    toast({
      type: 'error',
      content: '跳转参数不正确',
    });
  }
}

function onReportHandler(reportData: ReportHandlerData) {
  report({
    reportParamsList: [
      {
        operId: '1915000110201',
        groupId: reportData.gId,
        channelId: reportData.cId || '0',
        ext1: `${reportData?.reportInfo?.userType}`,
        toUid: reportData?.reportInfo?.toUid,
        messageType: MsgL2Type.MsgL2TypeCustomStructured,
        messageId: reportData?.reportInfo?.messageId,
      },
    ],
  });
}

function getWidth(width: number|undefined, scale: number) {
  if (!width) {
    return '100%';
  }
  return `${width * scale}px`;
}

export { pushUrl, getWidth };
